import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ImoDCSComponent } from './imo-dcs.component';

const routes: Routes = [
  {
    path: '',
    component: ImoDCSComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ImoDCSCRoutingModule {}
